import { indexData } from '@/mocks/homeData';

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            专题合集
          </h2>
          <p className="text-foreground-500 text-sm mt-2">按类型快速找到你想看的内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group flex items-center gap-3 md:gap-4 p-4 md:p-5 bg-background-100 rounded-xl hover:bg-primary-50 transition-all duration-200 cursor-pointer"
            >
              <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-background-50 group-hover:bg-primary-100 transition-colors duration-200 flex-shrink-0">
                <i className={`${item.icon} text-lg md:text-xl text-primary-600`}></i>
              </span>
              <div className="min-w-0">
                <div className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{item.title}</div>
                <div className="text-xs text-foreground-500 mt-0.5">{item.desc}</div>
                <div className="text-xs text-primary-600 font-medium mt-1">{item.count}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}